import React from 'react';
import Input from '../../forms/Input';
import { PATH } from '../util/paths';
import i18n from '../../../common/i18n';

const GridInput = ({ form, setInput }) => {
    return (
        <Input
            form={form}
            path={PATH.GRID_CODE}
            label={i18n('nui.two.fa.label.grid')}
            autocomplete="off"
            type="text"
            autocapitalize="off"
            onInput={e => setInput(e.target.value)}
            dataAtid="text-form-input-code"
        />
    );
};

export default GridInput;
